import { Quote, Star } from "lucide-react";
import { useEffect, useState } from "react";
import { fetchTestimonials } from "@/lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchTestimonials().then(setItems).catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <section id="omtaler" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[400px] h-[400px] rounded-full bg-coral/15 blur-[130px] pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl mb-14 sm:mb-20">
          <div className="mono text-[11px] uppercase tracking-[0.3em] text-coral mb-5 reveal">
            / Kundeomtaler
          </div>
          <h2 className="reveal text-4xl sm:text-6xl font-bold text-white leading-[1]" data-testid="testimonials-headline">
            Det <span className="text-gradient">kundene</span> sier.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <figure
              key={t.id}
              className="reveal relative p-7 rounded-3xl border hairline bg-[hsl(var(--hs-bg-2))] hover:border-cyan/30 transition-all group"
              style={{ transitionDelay: `${i * 90}ms` }}
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-7 h-7 text-cyan/50 mb-5" strokeWidth={1.5} />
              <blockquote className="text-white/85 text-[15px] leading-relaxed mb-6">
                "{t.quote}"
              </blockquote>
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star
                    key={`star-${idx}`}
                    className={`w-3.5 h-3.5 ${idx < (t.rating || 5) ? "text-coral fill-coral" : "text-white/20"}`}
                  />
                ))}
              </div>
              <figcaption className="flex items-center justify-between border-t hairline pt-4">
                <div>
                  <div className="text-white font-semibold">{t.name}</div>
                  {t.location && (
                    <div className="mono text-[10px] uppercase tracking-[0.2em] text-white/45">
                      {t.location}
                    </div>
                  )}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
